/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarUsuarioDto,
  CriarUsuarioDto,
  DefinirAtivoDto,
  DefinirCargoDto,
  ErroResponse,
  PaginaDeUsuariosResponse,
  UsuarioResponse,
  UsuariosControllerEnviarFotoBody,
  UsuariosControllerExportarCsvParams,
  UsuariosControllerListarParams
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getUsuariosControllerListarUrl = (params?: UsuariosControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/usuarios?${stringifiedParams}` : `/v1/admin/usuarios`
}

/**
 * @summary Lista usuários de TODOS os ambientes, paginado
 */
export const usuariosControllerListar = async (params?: UsuariosControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeUsuariosResponse> => {

  return httpClient<PaginaDeUsuariosResponse>(getUsuariosControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsuariosControllerListarQueryKey = (params?: UsuariosControllerListarParams,) => {
    return [
    `/v1/admin/usuarios`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsuariosControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof usuariosControllerListar>>, TError = ErroResponse>(params?: UsuariosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsuariosControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usuariosControllerListar>>> = ({ signal }) => usuariosControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsuariosControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof usuariosControllerListar>>>
export type UsuariosControllerListarQueryError = ErroResponse


export function useUsuariosControllerListar<TData = Awaited<ReturnType<typeof usuariosControllerListar>>, TError = ErroResponse>(
 params: undefined |  UsuariosControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usuariosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof usuariosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsuariosControllerListar<TData = Awaited<ReturnType<typeof usuariosControllerListar>>, TError = ErroResponse>(
 params?: UsuariosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usuariosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof usuariosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsuariosControllerListar<TData = Awaited<ReturnType<typeof usuariosControllerListar>>, TError = ErroResponse>(
 params?: UsuariosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista usuários de TODOS os ambientes, paginado
 */

export function useUsuariosControllerListar<TData = Awaited<ReturnType<typeof usuariosControllerListar>>, TError = ErroResponse>(
 params?: UsuariosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsuariosControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsuariosControllerCriarUrl = () => {




  return `/v1/admin/usuarios`
}

/**
 * @summary Cria usuário. Sem `tenantId`, cria um ambiente INDIVIDUAL próprio.
 */
export const usuariosControllerCriar = async (criarUsuarioDto: CriarUsuarioDto, options?: Parameters<typeof httpClient>[1]): Promise<UsuarioResponse> => {

  return httpClient<UsuarioResponse>(getUsuariosControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarUsuarioDto)
  }
);}





export const getUsuariosControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerCriar>>, TError,{data: CriarUsuarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerCriar>>, TError,{data: CriarUsuarioDto}, TContext> => {

const mutationKey = ['usuariosControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usuariosControllerCriar>>, {data: CriarUsuarioDto}> = (props) => {
          const {data} = props ?? {};

          return  usuariosControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsuariosControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof usuariosControllerCriar>>>
    export type UsuariosControllerCriarMutationBody = CriarUsuarioDto
    export type UsuariosControllerCriarMutationError = ErroResponse

    /**
 * @summary Cria usuário. Sem `tenantId`, cria um ambiente INDIVIDUAL próprio.
 */
export const useUsuariosControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerCriar>>, TError,{data: CriarUsuarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usuariosControllerCriar>>,
        TError,
        {data: CriarUsuarioDto},
        TContext
      > => {
      return useMutation(getUsuariosControllerCriarMutationOptions(options), queryClient);
    }
    export const getUsuariosControllerExportarCsvUrl = (params?: UsuariosControllerExportarCsvParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/usuarios/exportar.csv?${stringifiedParams}` : `/v1/admin/usuarios/exportar.csv`
}

/**
 * MESMO recorte de `listar` (busca, ambiente, status), mais o período por `criadoEm` — a tela nunca exporta um recorte diferente do que está mostrando.
 * @summary Exporta os usuários em CSV
 */
export const usuariosControllerExportarCsv = async (params?: UsuariosControllerExportarCsvParams, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getUsuariosControllerExportarCsvUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsuariosControllerExportarCsvQueryKey = (params?: UsuariosControllerExportarCsvParams,) => {
    return [
    `/v1/admin/usuarios/exportar.csv`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsuariosControllerExportarCsvQueryOptions = <TData = Awaited<ReturnType<typeof usuariosControllerExportarCsv>>, TError = unknown>(params?: UsuariosControllerExportarCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerExportarCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsuariosControllerExportarCsvQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usuariosControllerExportarCsv>>> = ({ signal }) => usuariosControllerExportarCsv(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerExportarCsv>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsuariosControllerExportarCsvQueryResult = NonNullable<Awaited<ReturnType<typeof usuariosControllerExportarCsv>>>
export type UsuariosControllerExportarCsvQueryError = unknown


export function useUsuariosControllerExportarCsv<TData = Awaited<ReturnType<typeof usuariosControllerExportarCsv>>, TError = unknown>(
 params: undefined |  UsuariosControllerExportarCsvParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerExportarCsv>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usuariosControllerExportarCsv>>,
          TError,
          Awaited<ReturnType<typeof usuariosControllerExportarCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsuariosControllerExportarCsv<TData = Awaited<ReturnType<typeof usuariosControllerExportarCsv>>, TError = unknown>(
 params?: UsuariosControllerExportarCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerExportarCsv>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usuariosControllerExportarCsv>>,
          TError,
          Awaited<ReturnType<typeof usuariosControllerExportarCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsuariosControllerExportarCsv<TData = Awaited<ReturnType<typeof usuariosControllerExportarCsv>>, TError = unknown>(
 params?: UsuariosControllerExportarCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerExportarCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Exporta os usuários em CSV
 */

export function useUsuariosControllerExportarCsv<TData = Awaited<ReturnType<typeof usuariosControllerExportarCsv>>, TError = unknown>(
 params?: UsuariosControllerExportarCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerExportarCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsuariosControllerExportarCsvQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsuariosControllerObterUrl = (id: string,) => {




  return `/v1/admin/usuarios/${id}`
}

/**
 * @summary Detalha um usuário
 */
export const usuariosControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<UsuarioResponse> => {

  return httpClient<UsuarioResponse>(getUsuariosControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsuariosControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/admin/usuarios/${id}`
    ] as const;
    }


export const getUsuariosControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof usuariosControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsuariosControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usuariosControllerObter>>> = ({ signal }) => usuariosControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsuariosControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof usuariosControllerObter>>>
export type UsuariosControllerObterQueryError = ErroResponse


export function useUsuariosControllerObter<TData = Awaited<ReturnType<typeof usuariosControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usuariosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof usuariosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsuariosControllerObter<TData = Awaited<ReturnType<typeof usuariosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usuariosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof usuariosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsuariosControllerObter<TData = Awaited<ReturnType<typeof usuariosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um usuário
 */

export function useUsuariosControllerObter<TData = Awaited<ReturnType<typeof usuariosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usuariosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsuariosControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsuariosControllerAtualizarUrl = (id: string,) => {




  return `/v1/admin/usuarios/${id}`
}

/**
 * @summary Atualiza dados de perfil. `papel` e `ativo` ficam fora.
 */
export const usuariosControllerAtualizar = async (id: string,
    atualizarUsuarioDto: AtualizarUsuarioDto, options?: Parameters<typeof httpClient>[1]): Promise<UsuarioResponse> => {

  return httpClient<UsuarioResponse>(getUsuariosControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarUsuarioDto)
  }
);}





export const getUsuariosControllerAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerAtualizar>>, TError,{id: string;data: AtualizarUsuarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerAtualizar>>, TError,{id: string;data: AtualizarUsuarioDto}, TContext> => {

const mutationKey = ['usuariosControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usuariosControllerAtualizar>>, {id: string;data: AtualizarUsuarioDto}> = (props) => {
          const {id,data} = props ?? {};

          return  usuariosControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsuariosControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof usuariosControllerAtualizar>>>
    export type UsuariosControllerAtualizarMutationBody = AtualizarUsuarioDto
    export type UsuariosControllerAtualizarMutationError = unknown

    /**
 * @summary Atualiza dados de perfil. `papel` e `ativo` ficam fora.
 */
export const useUsuariosControllerAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerAtualizar>>, TError,{id: string;data: AtualizarUsuarioDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usuariosControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarUsuarioDto},
        TContext
      > => {
      return useMutation(getUsuariosControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getUsuariosControllerDefinirAtivoUrl = (id: string,) => {




  return `/v1/admin/usuarios/${id}/ativo`
}

/**
 * @summary Ativa ou desativa. Efeito no request seguinte, sem relogin.
 */
export const usuariosControllerDefinirAtivo = async (id: string,
    definirAtivoDto: DefinirAtivoDto, options?: Parameters<typeof httpClient>[1]): Promise<UsuarioResponse> => {

  return httpClient<UsuarioResponse>(getUsuariosControllerDefinirAtivoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirAtivoDto)
  }
);}





export const getUsuariosControllerDefinirAtivoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoDto}, TContext> => {

const mutationKey = ['usuariosControllerDefinirAtivo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usuariosControllerDefinirAtivo>>, {id: string;data: DefinirAtivoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  usuariosControllerDefinirAtivo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsuariosControllerDefinirAtivoMutationResult = NonNullable<Awaited<ReturnType<typeof usuariosControllerDefinirAtivo>>>
    export type UsuariosControllerDefinirAtivoMutationBody = DefinirAtivoDto
    export type UsuariosControllerDefinirAtivoMutationError = ErroResponse

    /**
 * @summary Ativa ou desativa. Efeito no request seguinte, sem relogin.
 */
export const useUsuariosControllerDefinirAtivo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usuariosControllerDefinirAtivo>>,
        TError,
        {id: string;data: DefinirAtivoDto},
        TContext
      > => {
      return useMutation(getUsuariosControllerDefinirAtivoMutationOptions(options), queryClient);
    }
    export const getUsuariosControllerDefinirCargoUrl = (id: string,) => {




  return `/v1/admin/usuarios/${id}/cargo`
}

/**
 * @summary Atribui um cargo ao vínculo ativo do usuário
 */
export const usuariosControllerDefinirCargo = async (id: string,
    definirCargoDto: DefinirCargoDto, options?: Parameters<typeof httpClient>[1]): Promise<UsuarioResponse> => {

  return httpClient<UsuarioResponse>(getUsuariosControllerDefinirCargoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirCargoDto)
  }
);}





export const getUsuariosControllerDefinirCargoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerDefinirCargo>>, TError,{id: string;data: DefinirCargoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerDefinirCargo>>, TError,{id: string;data: DefinirCargoDto}, TContext> => {

const mutationKey = ['usuariosControllerDefinirCargo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usuariosControllerDefinirCargo>>, {id: string;data: DefinirCargoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  usuariosControllerDefinirCargo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsuariosControllerDefinirCargoMutationResult = NonNullable<Awaited<ReturnType<typeof usuariosControllerDefinirCargo>>>
    export type UsuariosControllerDefinirCargoMutationBody = DefinirCargoDto
    export type UsuariosControllerDefinirCargoMutationError = ErroResponse

    /**
 * @summary Atribui um cargo ao vínculo ativo do usuário
 */
export const useUsuariosControllerDefinirCargo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerDefinirCargo>>, TError,{id: string;data: DefinirCargoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usuariosControllerDefinirCargo>>,
        TError,
        {id: string;data: DefinirCargoDto},
        TContext
      > => {
      return useMutation(getUsuariosControllerDefinirCargoMutationOptions(options), queryClient);
    }
    export const getUsuariosControllerEnviarFotoUrl = (id: string,) => {




  return `/v1/admin/usuarios/${id}/foto`
}

/**
 * @summary Envia a foto de perfil do usuário. Exige proporção 1:1 (ex.: 400×400).
 */
export const usuariosControllerEnviarFoto = async (id: string,
    usuariosControllerEnviarFotoBody: UsuariosControllerEnviarFotoBody, options?: Parameters<typeof httpClient>[1]): Promise<UsuarioResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, usuariosControllerEnviarFotoBody.arquivo);

  return httpClient<UsuarioResponse>(getUsuariosControllerEnviarFotoUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUsuariosControllerEnviarFotoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerEnviarFoto>>, TError,{id: string;data: UsuariosControllerEnviarFotoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerEnviarFoto>>, TError,{id: string;data: UsuariosControllerEnviarFotoBody}, TContext> => {

const mutationKey = ['usuariosControllerEnviarFoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usuariosControllerEnviarFoto>>, {id: string;data: UsuariosControllerEnviarFotoBody}> = (props) => {
          const {id,data} = props ?? {};

          return  usuariosControllerEnviarFoto(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsuariosControllerEnviarFotoMutationResult = NonNullable<Awaited<ReturnType<typeof usuariosControllerEnviarFoto>>>
    export type UsuariosControllerEnviarFotoMutationBody = UsuariosControllerEnviarFotoBody
    export type UsuariosControllerEnviarFotoMutationError = ErroResponse

    /**
 * @summary Envia a foto de perfil do usuário. Exige proporção 1:1 (ex.: 400×400).
 */
export const useUsuariosControllerEnviarFoto = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerEnviarFoto>>, TError,{id: string;data: UsuariosControllerEnviarFotoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usuariosControllerEnviarFoto>>,
        TError,
        {id: string;data: UsuariosControllerEnviarFotoBody},
        TContext
      > => {
      return useMutation(getUsuariosControllerEnviarFotoMutationOptions(options), queryClient);
    }
    export const getUsuariosControllerRemoverFotoUrl = (id: string,) => {




  return `/v1/admin/usuarios/${id}/foto`
}

/**
 * @summary Remove a foto de perfil do usuário
 */
export const usuariosControllerRemoverFoto = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<UsuarioResponse> => {

  return httpClient<UsuarioResponse>(getUsuariosControllerRemoverFotoUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUsuariosControllerRemoverFotoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerRemoverFoto>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerRemoverFoto>>, TError,{id: string}, TContext> => {

const mutationKey = ['usuariosControllerRemoverFoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usuariosControllerRemoverFoto>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  usuariosControllerRemoverFoto(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsuariosControllerRemoverFotoMutationResult = NonNullable<Awaited<ReturnType<typeof usuariosControllerRemoverFoto>>>

    export type UsuariosControllerRemoverFotoMutationError = unknown

    /**
 * @summary Remove a foto de perfil do usuário
 */
export const useUsuariosControllerRemoverFoto = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usuariosControllerRemoverFoto>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usuariosControllerRemoverFoto>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getUsuariosControllerRemoverFotoMutationOptions(options), queryClient);
    }
